const apiErrorMappings = {
  name: { 'already exists': 'Sudah terdaftar di sistem.' },
}

export default apiErrorMappings
